import React, { useState } from "react";
import { colors } from "../../styles/colors";
import { useIsPremium } from "../../hooks/useIsPremium";
import UpgradeModal from "./UpgradeModal";

const SESSION_KEY = "upgrade_banner_dismissed";

export default function UpgradeBanner() {
  const isPremium = useIsPremium();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === "1"
  );
  const [modalOpen, setModalOpen] = useState(false);

  if (isPremium || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_KEY, "1");
    setDismissed(true);
  };

  return (
    <>
      <div
        className="flex flex-wrap items-center justify-between gap-2 rounded-xl px-4 py-2.5"
        style={{
          background: `linear-gradient(90deg, ${colors.brandPrimary}12 0%, ${colors.brandPrimary}08 100%)`,
          border: `1px solid ${colors.brandPrimary}25`,
        }}
      >
        <div className="flex min-w-0 flex-1 items-center gap-2.5">
          <span
            className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full"
            style={{ background: colors.brandPrimary, color: "#fff" }}
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5 1L6.18 3.4L9 3.82L7 5.77L7.45 8.59L5 7.3L2.55 8.59L3 5.77L1 3.82L3.82 3.4L5 1Z" fill="currentColor"/>
            </svg>
          </span>
          <p className="m-0 text-[13px]" style={{ color: colors.textPrimary }}>
            <span className="font-semibold">Free plan.</span>
            <span className="hidden sm:inline"> Upgrade for unlimited dreams, AI planning, and more.</span>
          </p>
        </div>

        <div className="flex flex-shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="rounded-lg border-0 px-3 py-1.5 text-[12px] font-semibold text-white transition-colors"
            style={{ background: colors.brandPrimary, cursor: "pointer" }}
          >
            Upgrade
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Dismiss banner"
            className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent transition-colors hover:bg-slate-100"
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5" stroke={colors.textTertiary} strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      </div>

      <UpgradeModal
        open={modalOpen}
        trigger="banner"
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}
